import CheckInCardContainer from './CheckInCardContainer';

export default CheckInCardContainer;
